import React, { useContext } from "react";
import AuthContext from "../Context/AuthContext";

export default function Footer() {
  const { loggedIn } = useContext(AuthContext);
  if (loggedIn) return null; // girişliyken footer'ı gizle

  const year = new Date().getFullYear();

  const LinkA = ({ href, children }) => (
    <a
      href={href}
      className="block py-1.5 text-sm text-slate-600 hover:text-slate-900"
    >
      {children}
    </a>
  );

  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-10">
        {/* üst kısım */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* logo + slogan */}
          <div>
            <a href="/" className="inline-flex items-center gap-3">
              <img
                src="/um.png"
                alt="Logo"
                className="h-12 w-12 object-contain"
              />
              <span className="sr-only">Home</span>
            </a>
            <p className="mt-4 text-sm text-slate-600">
              Better Media Buying
            </p>
          </div>

          {/* home */}
          <div>
            <h3 className="text-sm font-semibold text-slate-800 mb-3">HOME</h3>
            <LinkA href="/">Company</LinkA>
            <LinkA href="/tool">Tool</LinkA>
          </div>

          {/* about */}
          <div>
            <h3 className="text-sm font-semibold text-slate-800 mb-3">ABOUT US</h3>
            <LinkA href="/contact">Contact Us</LinkA>
            <LinkA href="/jobs">Job Opportunities</LinkA>
            <LinkA href="/portfolio">Portfolio</LinkA>
          </div>

          {/* address */}
          <div>
            <h3 className="text-sm font-semibold text-slate-800 mb-3">ADDRESS</h3>
            <p className="text-sm text-slate-600">
              🏠 Esentepe Mahallesi, Şişli / İstanbul
            </p>
            <a
              href="tel:+902123175700"
              className="block text-sm text-slate-600 hover:text-slate-900 mt-2"
            >
              📞 (0212) 317 57 00
            </a>
            <a
              href="mailto:pr@umww.com"
              className="block text-sm text-slate-600 hover:text-slate-900 mt-2"
            >
              📧 pr@umww.com
            </a>
          </div>
        </div>

        {/* alt bar */}
        <div className="mt-10 border-t border-slate-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-slate-500">
            © {year} Better Media Buying. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs">
            <a href="/privacy" className="text-slate-500 hover:text-slate-800">
              Privacy
            </a>
            <a href="/terms" className="text-slate-500 hover:text-slate-800">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
